export const INBOUND_LIST_API = 'inbounddb-lists/v1/segments-ui/searchLists';
export const DEFAULT_PREVIEW_CONFIG = {
  fontSize: 11
};
export const LIST_PROPERTIES = {
  LIST_SIZE: 'hs_list_size',
  LIST_NAME: 'hs_list_name',
  LIST_CLASSIC_ID: 'hs_classic_list_id',
  LIST_TYPE: 'hs_processing_type',
  PROCESSING_STATUS: 'hs_processing_status',
  DELETED_AT: 'hs_deleted_at',
  INBOUND_LIST_ID: 'hs_list_id',
  CREATED_AT: 'hs_created_at',
  UPDATED_AT: 'hs_updated_at',
  OBJECT_TYPE_ID: 'hs_object_type_id'
};
export const INBOUND_LIST_PROPERTIES = Object.values(LIST_PROPERTIES);